import sendPostType from './sendPostType'

const put = ({ path, data }) => sendPostType('PUT', { path, data })

export default put
